/* ========================================================================

 * DOM-based Routing

 * Based on http://goo.gl/EUTi53 by Paul Irish

 *

 * Only fires on body classes that match. If a body class contains a dash,

 * replace the dash with an underscore when adding it to the object below.

 *

 * .noConflict()

 * The routing is enclosed within an anonymous function so that you can

 * always reference jQuery with $, even when in .noConflict() mode.

 * ======================================================================== */



(function($) {



  // Use this variable to set up the common and page specific functions. If you

  // rename this variable, you will also need to rename the namespace below.

  var Sage = {

    // All pages

    'common': {

      init: function() {

        // JavaScript to be fired on all pages

        function viewMore(){

          $(".post-outer").slice(0, 9).addClass('unhide');  

          $(".campaign").slice(0, 1).addClass('unhide');  

          if ($('.post-outer').length <= 9 ){

              $(".loadmore-wrap").hide();

          } else {

            $(".loadmore-wrap").show();

          }

        }

        viewMore();



        $('.go-back').click(function() {

          window.history.back();

        });



      },

      finalize: function() {

        // JavaScript to be fired on all pages, after page specific JS is fired

        $("#loadmore").on('click', function (e) {

          e.preventDefault();

          $(".post-outer:hidden").slice(0, 9).addClass('unhide');

          $(".campaign:hidden").slice(0, 1).addClass('unhide');

          if ($(".post-outer:hidden").length === 0) {

            $("#load").fadeOut('slow');

          } 



          if ($('.post-outer:visible').length >= $('.post-outer').length ){

              $(".loadmore-wrap").hide();

          }

        });



        $(document).on('click','#search-toggle', function(){

          $('body').toggleClass('search-open');

          $('html').toggleClass('html-search-open');

          $('body').removeClass('menu-open');

        });



        //Load the Instagram Posts



        instaSlider = new Swiper('.instagram-content', {

          speed: 800,

          autoplay: {

            delay:2000,

          },

          slidesPerView: 5,

          spaceBetween: 8,

          breakpoints: {

            768: {

              slidesPerView: 1,

              spaceBetween: 4,

            }

          },

          loop: true,

          init: false

        });



        var itemCount = 8;



        $.ajax({

          type: "GET", 

          url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=5635491949.1677ed0.cd27725483c04ff5818ee50bc57aac8b&count="+itemCount,

          crossDomain: true,

          success: function(response) { 

              $.each(response.data, function(index, obj) {

                $('.instagram-inner').append('<div class="instagram-post swiper-slide"><a href="' + obj.link + '" target="_blank"><div class="img-container" style="background-image:url(' + obj.images.standard_resolution.url + ');"></div></a></div>');

              });

              instaSlider.init();

          },

      

          dataType: "jsonp" //set to JSONP, is a callback

        });



        ctaSlider = new Swiper('#cta-slider', {

          speed: 800,

          slidesPerView: 1,

          spaceBetween: 30,

          loop: false,

          breakpoints: {

            768: {

                spaceBetween: 8,

            }

          },

          pagination: {

            el: '#cta-pagination .swiper-pagination',

            type: 'bullets',

            clickable: true

          }

        });



        var callUrl = $('#postcall').val();



        function ajaxSearch(keyword){

          //Initial Product Load

          $.ajax({

            url: callUrl,

            data: "action=myfilter&keyword="+keyword, // form data

            type:'POST', // POST

            beforeSend:function(xhr){

            //filter.find('button').text('Processing...'); // changing the button label

            },

            success:function(data){

              //filter.find('button').text('Apply filter'); // changing the button label back

              $('#response').html(data); // insert data

            },

            error : function(error){ 

            },

            

          }).done(function(){

            var totalProducts = $('#response .post-result').length;

            $('#result-amount').html(totalProducts);

            $('.result-wrap').show();



            $('.loader').removeClass('active');

            $('.total-results').show();

          });

        }



        var timer;



        $('input#s').keyup(function(){

          var searchParam = $(this).val();

          clearTimeout(timer);  //clear any running timeout on key up

          timer = setTimeout(function() { //then give it a second to see if the user is finished

              //do .post ajax request //then do the ajax call

              if(searchParam.length > 0 ){

                $('#search-input-wrap').addClass('focused');

                $('.loader').addClass('active');

                ajaxSearch(searchParam);

              } else {

                $('#search-input-wrap').removeClass('focused');

                $('#response').html('');

                $('.total-results').hide();

              }              



          }, 1000);



        });



        $(document).on('click','#close, #search-clear',function(){

          $('input#s').val('');

          $('#search-input-wrap').removeClass('focused');

          $('#response').html('');

          $('.total-results').hide();

        });



        var searchWrapHeight = $('.response-wrapper').offset().top;



        var searchSize = searchWrapHeight + 50;



        $('.response-wrapper').css('max-height','calc(100vh - '+searchSize+'px)');







        $('#form-subscribe').validate({

          rules: {

            NAME: {

              required: true

            },

            EMAIL: {

              required: true,

              email: true

            },

            CONSENT: {

              required:true

            },

          },

          messages: {

            NAME: 'Nome é obrigatório',

            EMAIL: 'Email é obrigatório',

            CONSENT: 'Confirme que concorda com a Política de Privacidade.'

          },

          errorPlacement: function(error, element) 

          {

              if ( element.is(":checkbox")) {

                error.appendTo('.checkbox-validate' );

              } else {

                error.appendTo(element.parents('.input-wrap-inner') );

              }

          },

          highlight: function(element, errorClass, validClass) {

            $(element).parent('div').addClass(errorClass).removeClass(validClass);

          },

          unhighlight: function(element, errorClass, validClass) {

              $(element).parent('div').addClass(validClass).removeClass(errorClass);

          },

        });



        $('#form-send').click(function(e){

          e.preventDefault();

          var $form = $('#form-subscribe'); 

        });



        $(document).on('click','#menu-toggle',function(){

          $('body').toggleClass('menu-open');

          $('body').removeClass('search-open');

          $('html').removeClass('html-search-open');

        });



        $(window).on('load resize', function(){

          if($(window).width() > 768 ){

            $('#subscribe .button-subscribe').insertAfter('#subscribe .top-row .input-wrap-inner:nth-child(2)');

          } else {

            $('#subscribe .button-subscribe').insertAfter('#subscribe .bottom-row .wpcf7-form-control-wrap');

          }

        });

      }

    },

    // Home page

    'home': {

      init: function() {

        // JavaScript to be fired on the home page

        var highlights = new Swiper('#most-viewed-slider', {

          speed: 800,

          slidesPerView: 4,

          spaceBetween: 30,

          slidesPerGroup: 4,

          loop:false,

          init:false,

          breakpoints: {

            768: {

                slidesPerView: 1,

                slidesPerGroup: 1,

                spaceBetween: 15,

                init:true,

                loop: true

                /* pagination: {

                  el: '#most-viewed-pagination .swiper-pagination',

                  type: 'bullets',

                  clickable: true

                } */

            }

          },

          loop: true,

          loopFillGroupWithBlank: true,

          navigation: {

            prevEl: '.most-viewed-navigation .nav-prev',

            nextEl: '.most-viewed-navigation .nav-next'

          },

          on: {

            slideNextTransitionStart: function (){

            },

            slideNextTransitionEnd: function (){

            },

            slidePrevTransitionStart: function (){

            },

            slidePrevTransitionEnd: function (){

            }

          }

        });



        if($(window).width() < 769 ){

          highlights.init();

        }

      },

      finalize: function() {

        // JavaScript to be fired on the home page, after the init JS

      }

    },

    // About us page, note the change from about-us to about_us.

    'about_us': {

      init: function() {

        // JavaScript to be fired on the about us page

      }

    },

    'single_post':{

      init: function(){

          $('.entry-content ul li').html(function(){

            var text= $(this).text().trim().split(" ");

            var first = text.shift();

            return (text.length > 0 ? "<span class='red'>"+ first + "</span> " : first) + text.join(" ");

          });



          if($(window).width() <= 768){

            $('#article-social').css('max-height', $('.entry-content').outerHeight() + 134);  

          }

      }, 

      finalize: function() {

        var gallerySwiper = new Swiper('#gallery-slider', {

          speed: 800,

          loop: true,

          pagination: {

            el: '#gallery-pagination .swiper-pagination',

            type: 'bullets',

            clickable: true

          },

          navigation: {

            prevEl: '.gallery-navigation .nav-prev',

            nextEl: '.gallery-navigation .nav-next'

          }

          

        });



            //Scroll Function for Menu Animations

        $(window).on('scroll', function() {

        

            if ( $(window).width() > 768 ){

              var navScroll = $('#social-inner').offset().top - 64;

              var navPos = $(window).scrollTop();

          

              var scrollHeight = $('#article-social').outerHeight();

              var sideHeight = $('#social-inner .share-inner').height();

          

              var scrollEnd = scrollHeight - sideHeight + $('#social-inner').offset().top;



              if (navPos >= navScroll && navPos <= scrollEnd){

                $('body').addClass('scrollfix');

              } else {

                if (navPos >= scrollEnd ){

                  $('#social-inner').addClass('bottom');

                  $('body').removeClass('scrollfix');

                } else {

                  $('#social-inner').removeClass('bottom');

                  $('body').removeClass('scrollfix');

                }

              }



            } else {



              var navScroll = $('#social-inner').offset().top - 20;

              var navPos = $(window).scrollTop();



              var scrollHeight = $('.entry-content').outerHeight();        

              

              var sideHeight = $('#social-inner .share-inner').height();              



              var scrollEnd = scrollHeight - sideHeight + $('#social-inner').offset().top + 117;



              if (navPos >= navScroll && navPos <= scrollEnd){

                $('body').addClass('scrollfix');

              } else {

                if (navPos >= scrollEnd ){

                  $('#social-inner').addClass('bottom');

                  $('body').removeClass('scrollfix');

                } else {

                  $('#social-inner').removeClass('bottom');

                  $('body').removeClass('scrollfix');

                }

              }

            }

            

        });

        

        var relatedSwiper = new Swiper('#related-inner', {

          speed: 800,

          slidesPerView: 1,

          spaceBetween: 15,

          slidesPerGroup: 1,

        });



        $(window).on('load resize', function(){

          if($(window).width() > 768 ){

            $('#comments').insertBefore('#related');

            /* $('#related').insertBefore('#instagram');

            $('#related-inner').removeClass('swiper-container');

            $('#related-inner').addClass('row');

            $('.related-card').removeClass('swiper-slide');

            $('.related-card').addClass('col-md-4');

            $('.wrapper-switch').removeClass('swiper-wrapper'); */

          } else {

            $('#comments').insertBefore('#related-mobile');

            /* $('#related').insertBefore('#article-sidebar');

            $('#related-inner').addClass('swiper-container');

            $('.wrapper-switch').addClass('swiper-wrapper');

            $('.related-card').addClass('swiper-slide');

            $('#related-inner').removeClass('row');            

            $('.related-card').removeClass('col-md-4'); */

            



           



          }



         /*  if($(window).width() < 769 ){

            relatedSwiper.init();

          } */

        });



      }

    }

  };



  // The routing fires all common scripts, followed by the page specific scripts.

  // Add additional events for more control over timing e.g. a finalize event

  var UTIL = {

    fire: function(func, funcname, args) {

      var fire;

      var namespace = Sage;

      funcname = (funcname === undefined) ? 'init' : funcname;

      fire = func !== '';

      fire = fire && namespace[func];

      fire = fire && typeof namespace[func][funcname] === 'function';



      if (fire) {

        namespace[func][funcname](args);

      }

    },

    loadEvents: function() {

      // Fire common init JS

      UTIL.fire('common');



      // Fire page-specific init JS, and then finalize JS

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {

        UTIL.fire(classnm);

        UTIL.fire(classnm, 'finalize');

      });



      // Fire common finalize JS

      UTIL.fire('common', 'finalize');

    }

  };



  // Load Events

  $(document).ready(UTIL.loadEvents);



})(jQuery); // Fully reference jQuery after this point.

